export const APP_NAME = '贷款计算器 & 还贷模拟器';
export const APP_VERSION: string = __APP_VERSION__;
export const APP_LINK = 'https://loan.v2dl.net';
export const APP_AUTHOR = 'Tiger';
export const APP_AUTHOR_LINK = 'https://github.com/DropFan';
export const APP_COPYRIGHT = 'Copyright © 2025 David Tiger (DropFan@Gmail.com)';

/** 每月固定还款日（默认值） */
export const DEFAULT_REPAYMENT_DAY = 15;

/** 一天的毫秒数 */
export const MS_PER_DAY = 86_400_000;
